import styled from 'styled-components';

export const InboxStyled = styled.div(({ theme }) => ({
  borderRight: `2px solid ${theme.color.wfBlack}`,
  boxSizing: 'border-box',
  height: 'inherit',
  display: 'flex',
  flexDirection: 'column',
}));

export const InboxTitleWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const NoConversationsWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '20px',
  marginTop: '10%',
});

export const ProgressBarWrapper = styled.div({
  position: 'relative',
});
